export default __webpack_public_path__ + "static/media/2.93a26a37.jpg";